import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MenuController } from '@ionic/angular';
import { MenuData } from '../models/menu-data';
import { Util } from 'src/shared/util/util';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    selector: 'tidy-menu-bottom-buttons',
    templateUrl: 'tidy-menu-bottom-buttons.component.html',
    styleUrls: ['./tidy-menu-bottom-buttons.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMenuBottomButtonsComponent {

  @Input() menuData: MenuData;

  constructor(
    private navCtrl: CustomNavController,
    private menu: MenuController,
    private util: Util
  ) {

  }

  async goTo(target) {
    await this.menu.close();
    this.navCtrl.navigateForward(target);
  }

  help() {
    this.menu.close();
    const url = 'https://www.tidy.com/docs/pm/getting-started';
    this.util.openUrl(url);
  }
}
